export enum LocalStorageKeys {
    USER = 'user',
    ACCESS_TOKEN = 'accessToken',
    REFRESH_TOKEN = 'refreshToken',
    SHOW_PROFILE_PICTURE = 'showProfilePicture',
    SHOW_USER_IMAGE = 'showUserImage',
}

export const useLocalStorage = () => {
    const getItem = (key: string): string | null => {
        return localStorage.getItem(key)
    }

    const setItem = (key: string, value: unknown): void => {
        localStorage.setItem(key, JSON.stringify(value))
    }

    const getParsedItem = <T = unknown>(key: string): T | undefined => {
        const itemString = getItem(key)
        if (itemString) return JSON.parse(itemString) as T
        return undefined
    }

    const removeItem = (key: string): void => {
        localStorage.removeItem(key)
    }

    const clear = (): void => {
        localStorage.clear()
    }

    return {
        getItem,
        setItem,
        getParsedItem,
        removeItem,
        clear,
    }
}
